module.exports = __webpack_public_path__ + "img/ranch_ranchersland.5da489f.png";